<template>
  <div class="menu elevation-2" v-show="displayMenu" ref="menu">
    <v-sheet color="app-colors-background" class="menu-container" elevation="0">
      <v-container fluid @click="click">
        <v-row justify="center" class="menu-items-container ">
          <v-col cols="3" v-for="(headerItem, index) in headerItems" :key="index">
            <div class="menu-title">
              <span>{{headerItem.title}} </span>
            </div>
            <div class="menu-items d-flex flex-column headerBtns">
              <router-link v-for="(children, index) in headerItem.children" :key="index"
              :to="`/page/${children.pageId}`"
              >
              {{children.title}}
              </router-link>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="language === 'uk'">
          <v-col class="d-flex justify-center headerBtns">
            <v-btn
              v-if="link"
              dark
              color="#272727"
              elevation="0"
              class="text-decoration-none font-weight-bold menu-order-button  "
              :to="`/page/${link.pageId}`"
              >{{ link.buttonTitle }}</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
      <!-- svg -->
      <svg
        width="172"
        height="253"
        viewBox="0 0 172 253"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="svg-elipse"
      >
        <path
          d="M14.4155 219.756C26.5017 186.393 47.4326 156.831 71.3621 130.61C123.376 73.6149 190.745 30.7358 264.38 7.69915C278.983 3.12384 294.155 -0.711349 309.417 0.345345C319.441 1.04188 329.227 3.81434 339.251 4.18587C354.446 4.70934 369.833 -0.318225 384.681 2.9315C407.378 7.90079 422.097 31.6612 423.673 54.8256C425.248 77.9901 416.516 100.575 406.839 121.697C332.617 283.757 191.153 413.855 23.4234 474.355C21.4147 475.085 19.2559 475.808 17.1621 475.331C14.1758 474.656 12.3037 471.753 10.8906 469.048C-4.2782 439.588 8.45026 412.266 5.87226 381.929C2.87059 346.851 -1.26453 312.243 2.05457 276.98C3.88662 257.498 7.74529 238.176 14.4155 219.756Z"
          fill="#5D5D5D"
        />
      </svg>

      <svg
        width="72"
        height="73"
        viewBox="0 0 72 73"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="svg-circle"
      >
        <path
          d="M52.7249 61.0087C66.3352 51.8932 69.9905 33.4874 60.8891 19.8981C51.7877 6.30889 33.3763 2.68218 19.766 11.7977C6.15564 20.9131 2.50043 39.3189 11.6018 52.9082C20.7032 66.4974 39.1146 70.1242 52.7249 61.0087Z"
          stroke="#197979"
          stroke-width="12"
          stroke-miterlimit="10"
        />
      </svg>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="svg-circle-2"
      >
        <path
          d="M52.6024 60.7161C66.2127 51.6006 69.8679 33.1948 60.7665 19.6055C51.6652 6.01629 33.2537 2.38958 19.6434 11.5051C6.03309 20.6205 2.37787 39.0263 11.4792 52.6156C20.5806 66.2048 38.992 69.8315 52.6024 60.7161Z"
          stroke="#5E5D5D"
          stroke-width="12"
          stroke-miterlimit="10"
        />
      </svg>
    </v-sheet>
  </div>
</template>
<script>
import Cookie from 'vue-cookie'

export default {
  name: 'Menu',
  props: {
    value: {
      required: true
    }
  },
  async created() {
    if (this.link == null) {
      await this.$store.dispatch('loadSaleButtonSettings')
    }
    // const headerSetting = $this.store.getters.headerItems
    // this.HeaderColumns = JSON.parse(headerSetting.settingValue)
  },
  computed: {
    displayMenu: (vm) => vm.value,
    link: function () {
      return this.$store.getters.clientSettings
    },
    headerItems: function() {
      return this.$store.getters.headerItems
    },
    language: function () {
      const loc = Cookie.get('locale')
      return !loc ? 'uk' : loc
    }
  },
  methods: {
    hideOnClickOutside(element) {
      const outsideClickListener = (event) => {
        const burgerButton = document.getElementById('open-menu-button')
        if (
          !element.contains(event.target) &&
          !burgerButton.contains(event.target)
        ) {
          this.$emit('input', false)
        }
      }
      document.removeEventListener('click', outsideClickListener)
      document.addEventListener('click', outsideClickListener)
    },
    click(event) {
      if (
        event.target.tagName === 'A' ||
        event.target.parentElement.tagName === 'A'
      ) {
        this.$emit('input', false)
      }
    }
  },
  watch: {
    displayMenu: function (oldVal, newVal) {
      if (oldVal) {
        this.hideOnClickOutside(this.$refs.menu)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.menu {
  top: 6rem;
  z-index: 3;
  position: fixed;
  width: 100%;
  .container {
    max-width: 120rem;
    padding-top: 2.4rem;

    .menu-items-container {
      margin-bottom: 6.4rem;
    }
    .col {
      z-index: 1;
    }
    .menu-items {
      align-items: flex-start;
    }
    .menu-items :hover {
      a {
        align-items: flex-start;
        color: #8ac5ff;
      }
    }
    .menu-title {
      font-size: 2rem;

      span {
        color: #9a9a9a;
      }
    }

    .menu-items {
      a {
        color: white;
        text-decoration: none;
      }
    }
    .menu-order-button {
      font-size: 1.6rem;
      text-transform: none;
    }
  }
}
.headerBtns {
   color: white;

  a:hover {
    color: #8ac5ff !important;
  }
}
</style>
